import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';
import { prismVs } from './prism.styles';

export const Container = styled.div<{
  isSelected: boolean;
  isReadOnly: boolean;
}>`
  position: relative;
  padding: ${theme.spacing.medium};
  border-radius: ${theme.borderRadius.medium};
  background-color: ${theme.color.white};
  color: ${theme.color.designSystem.blackOpacity87};
  margin: ${theme.spacing.small} 0;
  ${({ isReadOnly }) => !isReadOnly && `padding-top: ${theme.spacing.xSmall}`};

  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.blackOpacity87}`
      : `1px solid ${theme.color.designSystem.blackOpacity12}`};

  // Styes for decorated syntax
  ${prismVs};
`;

export const StyledCode = styled.code`
  font-family: 'Roboto Mono', monospace;
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
`;

export const SelectContainer = styled.div`
  width: 200px;
  margin-bottom: ${theme.spacing.medium};
  user-select: none;
`;

export const Pre = styled.pre`
  margin: 0;
  overflow-x: auto;
`;

export const SyntaxLabel = styled.div`
  margin-bottom: ${theme.spacing.medium};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
`;

export const SyntaxName = styled.span`
  font-weight: ${theme.font.weight.semiBold};
`;
